<template>
  <el-row>
    <div id="toolbar" style="text-align: right;">
      <el-form :model="sk" name="searchForm" ref="searchForm" inline>
        <el-form-item label="订单号" prop="order_oederNo">
          <el-input v-model="sk.order_oederNo" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="getReviews(1)"><i class="fa fa-search"></i>评论搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="reviews" stripe>
        <el-table-column prop="ID" label="评论编号" width="100px;"></el-table-column>
        <el-table-column label="评论内容">
          <template slot-scope="d">
            <div v-html="d.row.reviewer"></div>
          </template>
        </el-table-column>
        <el-table-column label="买家" width="110">
          <template slot-scope="d">
            <el-button type="text" style="color: indianred">{{d.row.buyer.firstName | capitalize}} {{d.row.buyer.lastName | capitalize}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="评分" width="140">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.score" text-color="#FF9900" score-template="{value}" disabled show-score></el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="creatTime" label="创建时间" width="110"></el-table-column>
        <el-table-column label="评论操作" align="right" width="110">
          <template slot-scope="d">
            <el-button size="mini" type="text">评论认证</el-button>
            <el-button size="mini" type="text">解释说明</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        @current-change="getReviews"
        :current-page="currPage.page"
        :page-sizes="[15]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currPage.total">
      </el-pagination>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Review',
  data () {
    return {
      sk: {},
      reviews: [],
      currPage: {page: 1, total: 0},
      tableloading: false
    }
  },
  mounted () {
    this.getReviews(1)
  },
  methods: {
    getReviews: function (page) {
      var para = {}
      para.method = 'shop.commpage'
      para.sk = this.sk
      var that = this
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.reviews = ret.body.data.comtents
        that.currPage.total = ret.body.data.total
        that.currPage.page = page
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/Review.vue